import type { PreviewAsPickerCopy } from "./PreviewAsPicker.types";

/** Neutral defaults; owners pass wording that names their own field (for example "Preview as"). */
export const PREVIEW_AS_PICKER_COPY: PreviewAsPickerCopy = {
  label: "Preview as",
  previous: "Previous",
  next: "Next",
  position: (index, total) => `${index} of ${total}`,
  searchPlaceholder: "Search",
  menuLabel: "Preview as",
  empty: "Nothing matches",
  placeholder: "Choose one",
};
